// extracted by mini-css-extract-plugin
export var originalPrice = "_vw-0";